import type { AdModel, AdsFilteringType, UserModel, UserTariffPlanEnum } from '@/types';
import classnames from 'classnames';

import styles from './AdsListItem.module.scss';
import { AdsListItemCreatorInfo } from './AdsListItemCreatorInfo';
import { AdsListItemMainInfo } from './AdsListItemMainInfo';
import { AdsListItemMedia } from './AdsListItemMedia';
import { useAdsListItemController } from './useAdsListItemController';

interface AdsListItemProps {
  item: AdModel;
  type?: 'main' | 'favorite' | 'user';
  user?: UserModel;
  filteringObj?: AdsFilteringType;
  enableTopAgentHighlight?: boolean;
  isPromoted?: boolean;
  userId?: string;
  tariffPlan?: UserTariffPlanEnum;
  onSelectionClick?: (id: string, titleText: string) => void;
}

export const AdsListItem = ({
  enableTopAgentHighlight = false,
  filteringObj,
  isPromoted = false,
  item,
  onSelectionClick,
  tariffPlan,
  type,
  user,
  userId,
}: AdsListItemProps) => {
  const { creatorInfoProps, mainInfoProps, mediaProps } = useAdsListItemController({
    filteringObj,
    item,
    onSelectionClick,
    tariffPlan,
    type,
    user,
    userId,
  });
  const isTopAgentHighlighted =
    enableTopAgentHighlight && item.propertyAdCreator?.isAmbassador === true;

  return (
    <div
      className={classnames(styles.listItem, {
        [styles.topAgent]: isTopAgentHighlighted,
        [styles.promoted]: isPromoted,
      })}
    >
      <AdsListItemMedia {...mediaProps} />
      <AdsListItemMainInfo {...mainInfoProps}>
        <AdsListItemCreatorInfo {...creatorInfoProps} />
      </AdsListItemMainInfo>
    </div>
  );
};
